// generated by srcset-codegen
import src from "./envelope.svg";

const width = 20;
const height = 14;
export default { src, width, height };
